import React, { useState, useRef } from "react";
import Navbar from "../components/navbar";
import Footer from "../components/Footer";
import "../about/SplashPdfViewer.css";
import CTAButton from "../components/sticky-button";
import PageHeader from "../about/PageHeader";

const TechTonics = () => {
  const topRef = useRef(null);
   
const pdfList = [
  { id: 1, title: "Tech-Tonic Vol. 23", src: "/RD/techtonics/Tech-Tonic-Vol-23 Low.pdf", isWeb: false },
  { id: 2, title: "Tech-Tonic Vol. 22", src: "/RD/techtonics/Tech-Tonic-Cover-Vol-22-Low.pdf", isWeb: false },
  { id: 3, title: "Tech-Tonic Vol. 21", src: "/RD/techtonics/Tech-Tonic-Vol.-21-Web.pdf", isWeb: false },
  { id: 4, title: "Tech-Tonic Vol. 20", src: "/RD/techtonics/Tech-Tonic-Vol.-20.pdf", isWeb: false },
  { id: 5, title: "Tech-Tonic Vol. 19 (2024)", src: "/RD/techtonics/Tech-Tonic-Vol.-19-2024-Low.pdf", isWeb: false },
  { id: 6, title: "Tech-Tonic Vol. 18 (2023)", src: "/RD/techtonics/Tech-Tonic-Cover-Vol.-18-2023-index.pdf", isWeb: false },
  { id: 7, title: "Tech-Tonic Vol. 17", src: "/RD/techtonics/tech-tonics-index-vol-17.pdf", isWeb: false },
  { id: 8, title: "Tech-Tonic Vol. 16", src: "/RD/techtonics/tech-tonics-vol-16-index.pdf", isWeb: false },
  { id: 9, title: "Tech-Tonic Vol. 15 (2021)", src: "/RD/techtonics/Tech-Tonic-Vol.-15-2021-Final.pdf", isWeb: false },
  { id: 10, title: "Tech-Tonic Vol. 14 (2021)", src: "/RD/techtonics/Tech-Tonic-Vol-14-Final-2021.pdf", isWeb: false },
  { id: 11, title: "Tech-Tonic Vol. 13 (2021)", src: "/RD/techtonics/Tech-Tonic-Vol-13-Final-2021.pdf", isWeb: false },
  { id: 12, title: "Tech-Tonic Vol. 12 (2020)", src: "/RD/techtonics/Tech-Tonic-Vol.-12-2020-Final.pdf", isWeb: false },
  { id: 13, title: "Tech-Tonic Vol. 11", src: "/RD/techtonics/TechTonics-Vol-11a.pdf", isWeb: false },
  { id: 14, title: "Tech-Tonic Vol. 10", src: "/RD/techtonics/TechTonic-Vol-10.pdf", isWeb: false },
  { id: 15, title: "Tech-Tonic Vol. 9", src: "/RD/techtonics/TechTonic-Vol-9.pdf", isWeb: false },
  { id: 16, title: "Tech-Tonic Vol. 8", src: "/RD/techtonics/TechTonic-Vol-8.pdf", isWeb: false },
  { id: 17, title: "Tech-Tonic Vol. 7", src: "/RD/techtonics/TechTonic-Vol-7.pdf", isWeb: false },
  { id: 18, title: "Tech-Tonic Vol. 6", src: "/RD/techtonics/TechTonic-Vol-6.pdf", isWeb: false },
  { id: 19, title: "Tech-Tonic Vol. 5", src: "/RD/techtonics/TechTonic-Vol-5.pdf", isWeb: false },
  { id: 20, title: "Tech-Tonic Vol. 4", src: "/RD/techtonics/TechTonic-Vol-4.pdf", isWeb: false },
  { id: 21, title: "Tech-Tonic Vol. 3", src: "/RD/techtonics/TechTonic-Vol-3.pdf", isWeb: false },
  { id: 22, title: "Tech-Tonic Vol. 2", src: "/RD/techtonics/TechTonic-Vol-2.pdf", isWeb: false },
  { id: 23, title: "Tech-Tonic Vol. 1", src: "/RD/techtonics/TechTonic-Vol-1.pdf", isWeb: false },
];
  const [activePdf, setActivePdf] = useState(pdfList[0]);
   
  const handlePdfSelection = (pdf) => {
    if (topRef.current) {
      topRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
   
    if (pdf.isWeb) {
      window.open(pdf.src, "_blank");
    } else {
      setActivePdf(pdf);
    }
  };
   
  return (
    <>
      <Navbar />
      <CTAButton />
   
      <div className="spv-modern-portal">
        <div ref={topRef}>
          <PageHeader 
            title="TechTonics" 
            crumbs={[{ label: 'Home', href: '/' }, { label: 'TechTonics' }]} 
          />
        </div>
   
        <div className="spv-main-content">
          <aside className="spv-sidebar-modern">
            <div className="spv-sidebar-header-text">TECHTONICS VOLUMES</div>
            <p style={{ padding: '1rem', fontSize: '0.9rem', lineHeight: '1.6', color: '#555', textAlign: 'justify' }}>
              TechTonics is a biannual research journal which publishes a collection of scholarly research papers written by students of MCA on various advanced technologies. TechTonics is allocated the ISSN2455-071X by National Science Library (NSL). The research journal aims to inculcate the ability to think and elaborate new ideas amongst the students in the dynamic field of Information Technology.
            </p>
            <nav className="spv-nav-group">
              {pdfList.map((item) => (
                <button
                  key={item.id}
                  className={`spv-nav-card ${activePdf.id === item.id ? "is-active" : ""}`}
                  onClick={() => handlePdfSelection(item)}
                >
                  <div className="spv-card-content">
                    <img 
                      src="/images/icons/pdf.svg" 
                      alt="icon" 
                      className="spv-doc-icon-img" 
                    />
                    <span className="spv-card-text">{item.title}</span>
                    <img 
                      src="/images/icons/move.webp" 
                      alt="arrow icon" 
                      className="spv-doc-icon-img" 
                    />
                  </div>
                </button>
              ))}
            </nav>
          </aside>
   
          <main className="spv-viewer-area" key={activePdf.id}>               
            <header className="spv-viewer-topbar">
              <div className="spv-info-stack">
                <h2 className="spv-doc-title">{activePdf.title}</h2>
              </div>
              <div className="spv-action-group">
                <button className="spv-btn spv-btn-outline" onClick={() => window.open(activePdf.src)}>
                  Full Screen
                </button>
              </div>
            </header>
   
            <div className="spv-pdf-viewport">
              <div className="spv-pdf-card no-select">
                <iframe
                  src={`${activePdf.src}#toolbar=0&navpanes=0&scrollbar=0`}
                  className="spv-iframe-content secure-frame"
                  title="Document Viewer"
                  onContextMenu={(e) => e.preventDefault()}
                />
              </div>
            </div>
          </main>
        </div>
      </div>
         
      <Footer />
    </>
  );
};

export default TechTonics;